<template>
	<div class="layout-footer w-full">
		<!-- <img alt="Logo" :src="darkTheme ? 'images/logo-dark.svg' : 'images/logo-white.svg'" height="20" class="mr-2" />
		by -->
		<!-- <span class="font-medium ml-2">
			Copyright &copy; {{currentYear}} <b>Wilmar Group Indonesia</b>. All rights reserved.
		</span> -->
		<div class="grid w-full">
			<div class="col-6">
				<span class="footer-text">
					Copyright &copy; {{currentYear}} <b>Wilmar Group Indonesia</b>. All rights reserved.
				</span>
				
			</div>
			<div class="col-6 text-right">
				<span class="footer-text">
					{{version}}
				</span>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "AppFooter",
		props:{
			version: {
				type: String,
				default: "[] v.0.0"
			}
		},
		computed: {
			darkTheme() {
				return this.$appState.theme.startsWith('saga');
			},
			currentYear(){
				return new Date().getFullYear();
			}
		},
	}
</script>

<style scoped>

</style>